export interface RecordBase {
  id: string;
  createdAt: string;
  updatedAt: string;
  revision: number;
  source: 'user';
  archivedAt: string | null;
  deletedAt: string | null;
}

export interface Capture extends RecordBase {
  body: string;
  attachmentIds: string[];
  state: 'inbox' | 'organized';
}

export interface Draft {
  deletedAt?: string | null;
  id: string;
  captureId: string;
  baseRevision: number;
  body: string;
  attachmentIds: string[];
  revision: number;
  state: 'active' | 'conflict';
  createdAt: string;
  updatedAt: string;
}

export interface Attachment extends RecordBase {
  name: string;
  mime: string;
  bytes: number;
  sha256: string;
  indexStatus: 'metadata_only';
}
export interface AttachmentBlob { sha256: string; blob: Blob; bytes: number }
export interface PreparedAttachment { metadata: Attachment; data: AttachmentBlob }

export interface Operation {
  id: string;
  kind: 'save-draft' | 'publish' | 'discard-draft' | 'trash' | 'restore' | 'purge' | 'restore-revision' | 'item-save' | 'item-state' | 'organize' | 'undo-organize' | 'project-end' | 'directive' | 'item-draft' | 'content-save' | 'content-draft' | 'content-state' | 'sop-command' | 'study-command';
  fingerprint: string;
  resultId: string;
  resultRevision: number;
  committedAt: string;
}
export interface Meta { key: string; value: string | number }
export interface Setting { key: string; value: string | boolean }
export interface Control { key: string; value: string }

export interface CaptureRevision {
  id: string;
  captureId: string;
  revision: number;
  reason: 'created' | 'edited' | 'trashed' | 'restored' | 'history-restored' | 'migration-baseline' | 'organized' | 'undo-organize';
  recordedAt: string;
  snapshot: Capture;
}

export interface SaveDraftInput {
  operationId: string;
  draftId: string;
  captureId: string;
  baseRevision: number;
  expectedDraftRevision: number;
  body: string;
  attachmentIds: string[];
  prepared?: PreparedAttachment[];
}

export function displayTitle(body: string): string {
  return body.trim().split('\n').find((line) => line.trim())?.trim().slice(0, 80) || '图片记录';
}

export function hasContent(body: string, attachmentIds: string[]): boolean {
  return body.trim().length > 0 || attachmentIds.length > 0;
}
